var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrownLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0943 16.1826L21.5147 16.8811C20.5529 17.3066 19.9405 18.2986 19.9912 19.3491L20.0521 20.6225C20.0797 21.195 19.8156 21.7331 19.3464 22.0619C18.8744 22.3924 18.36 22.4311 17.8247 22.2581C17.4279 22.1297 16.9691 21.9047 16.5763 21.7399C15.6074 21.3332 14.4652 21.5693 13.7359 22.3281L12.5397 23.5736C12.1499 23.9794 11.6088 24.1557 11.0547 24.058C10.5007 23.9606 10.0523 23.6092 9.82474 23.0948L9.12649 21.5159C8.70106 20.5536 7.70563 19.9399 6.65867 19.9915L5.38483 20.0527C4.81234 20.0805 4.27449 19.8165 3.9455 19.3466C3.61681 18.8768 3.55294 18.2812 3.77464 17.7527L4.26774 16.5769C4.6744 15.6068 4.43816 14.4651 3.67966 13.7363L2.43417 12.54C2.02834 12.1502 1.85146 11.609 1.94915 11.055C2.04684 10.5009 2.39817 10.0528 2.91284 9.82537L4.49247 9.12663C5.45445 8.70145 6.06656 7.70971 6.01658 6.65876L5.95541 5.38492C5.92784 4.81248 6.19193 4.27434 6.66108 3.94584C7.13028 3.61704 7.72576 3.55253 8.25503 3.77497L9.43118 4.26783C10.4029 4.67599 11.5429 4.43854 12.2715 3.6797L13.4675 2.43416C13.857 2.02797 14.3985 1.85144 14.9525 1.94913C15.5065 2.04682 15.9547 2.39785 16.1822 2.91223L16.8804 4.49175C17.3061 5.45414 18.2985 6.06759 19.3482 6.01586L20.622 5.95499C21.1954 5.92698 21.7332 6.19162 22.0614 6.66071C22.3901 7.13021 22.454 7.72588 22.2323 8.25437L21.7395 9.43052C21.3325 10.4006 21.5687 11.5422 22.327 12.2707L23.5724 13.4676C23.9779 13.8573 24.1548 14.3986 24.0571 14.9526C23.9603 15.5071 23.609 15.9549 23.0943 16.1826Z",
    fill: "url(#paint0_linear_295_95088)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3581 12.1748C17.3911 11.9875 17.3036 11.7998 17.139 11.7047C16.974 11.6111 16.7679 11.628 16.6223 11.751L14.8583 13.233L14.1099 9.31336C14.1077 9.1294 13.9898 8.96358 13.811 8.89809C13.5929 8.81802 13.3541 8.92125 13.2476 9.12247L11.1829 12.5846L10.0322 10.5887C9.9374 10.4236 9.74927 10.3365 9.5624 10.3691C9.37513 10.4021 9.22875 10.5486 9.19573 10.7358L8.51437 14.6001C8.39559 15.2737 8.84704 15.9184 9.52095 16.0372L15.2392 17.0455C15.9128 17.1643 16.5578 16.7132 16.6767 16.0393L17.3581 12.1748Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2108 24.7146C16.0925 24.6319 15.9418 24.6105 15.8054 24.6572C15.669 24.7038 15.5629 24.8127 15.5198 24.9507L14.7568 27.4075L13.5739 23.802L14.389 22.9534C14.8605 22.462 15.5994 22.3095 16.2277 22.5727L17.3702 23.0517L18.4246 26.2652L16.2108 24.7146Z",
    fill: "url(#paint1_linear_295_95088)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_295_95088",
    x1: 8.31033,
    y1: 21.0912,
    x2: 21.1104,
    y2: 5.87161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF820E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_295_95088",
    x1: 14.9169,
    y1: 26.8764,
    x2: 17.7776,
    y2: 23.3879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF820E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA0E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownLogo);
export default __webpack_public_path__ + "static/media/crownLogo.667afb652d698056e895c2a9717aceef.svg";
export { ForwardRef as ReactComponent };